/**
 * A class defines required employees prediction for a specific hour.
 */
export class HourlyRequiredEmployeePrediction {
  hour: number;
  prediction: number;

  /**
   * @param hour the hour of required employee prediction.
   * @param prediction the predicted number of required minimum employees.
   */
  constructor(hour: number, prediction: number) {
    this.hour = hour;
    this.prediction = prediction;
  }
}
